<div *ngIf="(itemName$ | async) === 'agent_item'" class="flex justify-content-left">
  <p-button (onClick)="doShowDialog(true)">Sudski registar</p-button>
</div>

<p-dialog
  *ngIf="showDialog"
  [resizable]="false"
  [(visible)]="showDialog"
  [modal]="true"
  [draggable]="false"
  appendTo="body"
>
  <ng-template pTemplate="header">
    <h3>Sudski registar</h3>
  </ng-template>

  <div class="field md:flex gap-2 align-items-center">
    <label for="oib" class="property-label">OIB: </label>

    <input
      id="oib"
      class="p-inputtext p-component"
      [formControl]="identifikator"
    />

    <p-button
      [disabled]="!identifikator.valid"
      (onClick)="onSubmit()"
      label="Pretraži"
    ></p-button>
  </div>

  <div *ngIf="dirty && !!!sudskiRegistarResponseO">
    Nije pronađen nijedan zapis u Sudskom registru!
  </div>
  <p-message *ngIf="fetchError" severity="error" [text]="fetchError"></p-message>
  <div *ngIf="sudskiRegistarResponseO">
    <div class="flex align-items-center gap-3">
      <p-button [disabled]="!sudskiRegistarResponseO || !identifikator.value || identifikator.invalid" (onClick)="apply()"
        >Primijeni</p-button
      >
      <h4>{{ sudskiRegistarResponseO['tvrtke'][0].ime }}</h4>
    </div>

    <p-fieldset legend="Detalji" [toggleable]="true">
      <ul>
        <li class="md:flex">
          <strong class="w-13rem">Mbs:</strong>
          <p>{{ sudskiRegistarResponseO.mbs }}</p>
        </li>
        <li class="md:flex">
          <strong class="w-13rem">OIB:</strong>
          <p>{{ sudskiRegistarResponseO.oib }}</p>
        </li>
        <li class="md:flex" *ngIf="sudskiRegistarResponseO['email_adrese']">
          <strong class="w-13rem">Adresa elektroničke pošte:</strong>
          <p>{{ sudskiRegistarResponseO['email_adrese'][0].adresa }}</p>
        </li>
      </ul>
    </p-fieldset>

    <p-fieldset legend="Ostali nazivi" [toggleable]="true">
      <ol>
        <li *ngFor="let altNames of sudskiRegistarResponseO['skracene_tvrtke']">
          {{ altNames.ime }}
        </li>
      </ol>
    </p-fieldset>
  </div>
  <p-message *ngIf="applyError" severity="error" [text]="applyError"></p-message>

  <ng-template pTemplate="footer">
    <div class="flex">
      <p-button (onClick)="doShowDialog(false)">Zatvori</p-button>
    </div>
  </ng-template>
</p-dialog>
